import { useEffect, useState } from 'react'

export type TenantLogoConfig = {
  logoPath?: string
  logoPathLight?: string
  logoPathDark?: string
}

function pickSrc(cfg: TenantLogoConfig, dark: boolean): string | undefined {
  const fb = cfg.logoPath?.trim()
  const light = cfg.logoPathLight?.trim()
  const darkp = cfg.logoPathDark?.trim()
  if (!fb && !light && !darkp) return undefined
  if (dark) return darkp || fb
  return light || fb
}

export function pickTenantLogoSrc(cfg: TenantLogoConfig, dark: boolean): string | undefined {
  return pickSrc(cfg, dark)
}

/**
 * Resolves tenant logo path for light/dark; follows `document.documentElement` `.dark` like Labs theme.
 */
export function useTenantLogoSrc(cfg: TenantLogoConfig): string | undefined {
  const [src, setSrc] = useState<string | undefined>(() =>
    typeof document !== 'undefined' ? pickSrc(cfg, document.documentElement.classList.contains('dark')) : cfg.logoPath
  )

  useEffect(() => {
    const sync = () => setSrc(pickSrc(cfg, document.documentElement.classList.contains('dark')))
    sync()
    const mo = new MutationObserver(sync)
    mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] })
    return () => mo.disconnect()
  }, [cfg.logoPath, cfg.logoPathLight, cfg.logoPathDark])

  return src
}
